import React from "react";
import { usePageSystemViewHook } from "./system-view-hooks";

type ContextSystemView = ReturnType<typeof usePageSystemViewHook>;
export const SystemViewContext = React.createContext<ContextSystemView | null>(
  null,
);

export function useContextSystemView() {
  const context = React.useContext(SystemViewContext);

  if (!context) {
    throw new Error(
      "useContextContextSystemView must be used within a ContextSystemViewProvider",
    );
  }

  return context;
}
